import React from 'react';
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import { SingleCollapse } from "@/components/";
import NormalIndicator from './NormalIndicator';
import DetailIndicator from './DetailIndicator';
import { Enums } from "@utils";

export interface IPropsStep {
    stepsData: any,
    infoToDelete: any,
    year: any,
    dataColumns: any
}

const Indicators: React.FC<IPropsStep> = ({stepsData, infoToDelete, year, dataColumns} : IPropsStep) => {

    const view: any = {
        state: {
        },
    };
      
    const presenter = new PopAdminPresenter(view);
    
    let hasInfo = infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoLineaPrincipal || x.listName === Enums.ListTypes.SeguimientoLineaSecundaria ||
        x.listName === Enums.ListTypes.SeguimientoResultadosInstitucionales || x.listName === Enums.ListTypes.SeguimientoProductosInstitucionales ||
        x.listName === Enums.ListTypes.SeguimientoActividades || x.listName === Enums.ListTypes.SeguimientoResultadosEsperados || x.listName === Enums.ListTypes.SeguimientoIndObjEspecificos))

    return (
        <>
            { !!dataColumns && !!hasInfo?.length &&
                <SingleCollapse title={presenter.followupLabels.get("stepIndicators")} isOpen={false}>
                    <>
                        <NormalIndicator 
                            stepsData={stepsData}
                            sectionName={presenter.followupLabels.get("mainStrategicLine")}
                            section={"mainIndicator"}
                            year={year}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoLineaPrincipal) ).map((y: any) => y.item)}
                        />
                        <NormalIndicator
                            year={year} 
                            stepsData={stepsData}
                            sectionName={presenter.followupLabels.get("secondaryStrategicLine")}
                            section={"secondIndicator"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoLineaSecundaria) ).map((y: any) => y.item)}
                        />
                        <NormalIndicator
                            year={year} 
                            stepsData={stepsData}
                            sectionName={presenter.followupLabels.get("outcomeIndicators")}
                            section={"resultsIndicators"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoResultadosInstitucionales) ).map((y: any) => y.item)}
                        />
                        <DetailIndicator
                            year={year} 
                            stepsData={stepsData}
                            sectionName={presenter.followupLabels.get("productIndicators")}
                            section={"productsIndicators"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoProductosInstitucionales) ).map((y: any) => y.item)}
                        />

                        <NormalIndicator
                            year={year} 
                            stepsData={stepsData}
                            sectionName={presenter.followupLabels.get("specificGoal")}
                            section={"objetives"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoIndObjEspecificos) ).map((y: any) => y.item)}
                        />
                        <NormalIndicator
                            year={year} 
                            stepsData={stepsData}
                            sectionName={presenter.followupLabels.get("indicatorsExpectedResultTitle")}
                            section={"results"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoResultadosEsperados) ).map((y: any) => y.item)}
                        />
                        <DetailIndicator
                            year={year} 
                            stepsData={stepsData}
                            sectionName={presenter.followupLabels.get("activitiesTitle")}
                            section={"activities"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.SeguimientoActividades) ).map((y: any) => y.item)}
                        />
                    </>
                </SingleCollapse>
            }
        </>
    )
}

export default Indicators;